module.exports = __webpack_public_path__ + "img/bba.e8a6abee.png";